module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-phauat-api.rugcc.org/api/v1",
        current_environment : "phauat"
    }
};